export default {
  //organizations
  CREATED_ORGANIZATION: 'Created an Organization',
  //venues
  CREATED_VENUE: 'Created a Venue',
  //events events
  VIEWED_EVENT_CALENDAR_VIEW: 'Viewed Event Calendar View',
  VIEWED_EVENT_LIST_VIEW: 'Viewed Event List View',
  CREATED_EVENT: 'Created an Event',
  //staff events
  CREATED_STAFF_MEMBER: 'Created a Staff Member',
  //promoter events
  CREATED_PROMOTER: 'Created a Promoter',
  //performance/reports events
  DOWNLOADED_RESERVATION_PERFORMANCE_REPORT: 'Downloaded Reservation Performance Report',
  DOWNLOADED_GUESTLIST_PERFORMANCE_REPORT: 'Downloaded Guestlist Performance Report',
  //admission group events
  CREATED_RESERVATION: 'Created a Reservation',
  CHECKED_IN_RESERVATION: 'Checked In Reservation',
  CREATED_GUESTLIST: 'Created a Guestlist',
  CHECKED_IN_GUESTLIST: 'Checked In a Guestlist',
  //customer evnets
  CREATED_CUSTOMER: 'Created a Customer',
  FILTERED_CUSTOMERS_BY_NAME: 'Filtered Customers By Name',
  FILTERED_CUSTOMERS_BY_TAGS: 'Filtered Customers By Tags',
  FILTERED_CUSTOMERS_BY_CONTACT_INFO: 'Filtered Customers By Contact Info',
  FILTERED_CUSTOMERS_BY_GENDER: 'Filtered Customers By Gender',
  FILTERED_CUSTOMERS_BY_BIRTHDAY: 'Filtered Customers By Birthday',
  //login/logout
  LOGGED_IN: 'Logged In',
  LOGGED_OUT: 'Logged Out',
  REGISTERED: 'Registered',
  COMPLETED_ACCOUNT_SETUP: 'Completed Account Setup',
  COMPLETED_ACCOUNT_SETUP_STEP: 'Completed Account Setup Step',
  //sign up
  // SUBMITTED_CREATE_ACCOUNT_FORM: 'Submitted Create Account Form',
  // SETUP_ACCOUNT: 'Setup Account',
  // SIGNED_UP: 'Signed Up',
  //misc events
  CLICKED_ENABLE_TABLELIST_BUTTON: 'Clicked Enable Tablelist Button',
  CLICKED_EVENT_PUBLIC_PAGE_BUTTON: 'Clicked Event Public Page Button',
  CLICKED_EVENT_TABLELIST_PAGE_BUTTON: 'Clicked Event Tablelist Page Button',
  //Payment Profile Events
  ADD_PAYMENT_PROFILE: 'Added a new Payment Profile',
  SET_PAYMENT_PROFILE: 'Set a Payment Profile'
};



// WEBPACK FOOTER //
// ./src/constants/segmentEvents.js